function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e0b36a3e-b435-47d4-a6c4-24e8fd6c7cfc{fill:#ffb7b7;}.\\38 cbf06d0-48b8-4851-867c-3ab61e906cfa,.e0b36a3e-b435-47d4-a6c4-24e8fd6c7cfc{isolation:isolate;}.\\31 c4a4057-07a6-460b-866f-19925928e143{fill:#f48484;}.\\39 b71878e-a833-4561-9fb1-cee8ce7f49e9{fill:#b1a0bb;}.ce81bdd5-089b-4c27-9d1a-d7c9fb985c91{fill:#d3ecee;}.\\35 894025d-9416-4ce5-8ae4-b9117d114124{fill:#633a69;}.\\36 6d0723c-5ba0-452b-9a77-a5c214749042{fill:#f9384f;}.\\31 9c824ba-e2a3-4f2b-b719-59b7dab2ee43{fill:#7a66a3;}.\\30 83a53d4-6237-422f-b786-ee3c3dc67dff{fill:#f2f2f2;stroke:#724279;stroke-miterlimit:10;stroke-width:0.858px;}.eb52c4bf-ee7c-4861-8337-fa16df875521{fill:#fff;}.\\38 cbf06d0-48b8-4851-867c-3ab61e906cfa{opacity:0.1;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "industry");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "5d9c346a-7af9-4dcb-8f7e-c3d9668060ce",
  "data-name": "Group 110"
}, /*#__PURE__*/React.createElement("path", {
  className: "e0b36a3e-b435-47d4-a6c4-24e8fd6c7cfc",
  d: "M95.088,25.52c-8.34-1.6-15.936-5.292-23.136-9.149S57.671,8.377,49.714,5.668C44.6,3.926,38.6,2.833,33.957,4.665c-4.468,1.76-6.455,5.716-7.785,9.481-1,2.827-1.806,5.841-.782,8.8C26.1,25,27.646,26.883,28.6,28.9c3.323,7-.989,14.291-6.673,19.7-2.665,2.536-5.665,4.881-7.859,7.685s-3.545,6.2-2.56,9.578c.976,3.34,4.114,6.245,7.656,8.5,7.195,4.577,16.147,6.992,24.946,8.959,19.471,4.352,39.32,7,59.119,9.642a195.759,195.759,0,0,0,22.025,2.1c4.076.082,8.332-.144,11.569-1.816,4.108-2.123,5.755-6.57,3.839-10.366-3.213-6.368-14.4-9.616-16.305-16.2-1.047-3.625,1.185-7.117,4-9.873,6.028-5.91,15.271-10.461,16.937-18.056,1.145-5.215-2-11.127-7.77-14.607-6.048-3.647-15.068-4.758-20.53-1.2C111.361,26.6,102.454,26.93,95.088,25.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "1c4a4057-07a6-460b-866f-19925928e143",
  d: "M122.718,32.3s30.46,12.207,32.336,32.784-12.1,31.175-27.09,18.694-45.673-16.851-64.39.38-42,12.923-41.043-9.788,3.142-25.364,28.809-55.657,40.326.064,47.761,3.1S122.718,32.3,122.718,32.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "9b71878e-a833-4561-9fb1-cee8ce7f49e9",
  d: "M119.642,27.221a45.442,45.442,0,0,0-73.357-6.777L43.36,17.889a49.318,49.318,0,0,1,79.624,7.354Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ce81bdd5-089b-4c27-9d1a-d7c9fb985c91",
  d: "M121.472,77.814l-3.223-2.167a45.465,45.465,0,0,0,1.393-48.426l3.342-1.978A49.349,49.349,0,0,1,121.472,77.814Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "5894025d-9416-4ce5-8ae4-b9117d114124",
  d: "M43.765,83.225a49.315,49.315,0,0,1-.4-65.336l2.925,2.556a45.432,45.432,0,0,0,.373,60.189Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "66d0723c-5ba0-452b-9a77-a5c214749042",
  d: "M80.513,99.652A49.4,49.4,0,0,1,43.765,83.225l2.893-2.591a45.441,45.441,0,0,0,71.591-4.987l3.223,2.167A49.29,49.29,0,0,1,80.513,99.652Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "19c824ba-e2a3-4f2b-b719-59b7dab2ee43",
  points: "167.408 97.61 114.316 97.61 114.316 78.535 115.133 78.535 115.133 96.94 167.408 96.94 167.408 97.61"
}), /*#__PURE__*/React.createElement("circle", {
  className: "19c824ba-e2a3-4f2b-b719-59b7dab2ee43",
  cx: 114.725,
  cy: 82.307,
  r: 4.492
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "9b71878e-a833-4561-9fb1-cee8ce7f49e9",
  cx: 82.242,
  cy: 105.918,
  rx: 59.923,
  ry: 2.974
}), /*#__PURE__*/React.createElement("path", {
  className: "9b71878e-a833-4561-9fb1-cee8ce7f49e9",
  d: "M43.3,90.466c-10.289,5.183-7.584,14.286-7.584,14.286Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "9b71878e-a833-4561-9fb1-cee8ce7f49e9",
  d: "M22.32,95.254c11.983.563,13.056,9.548,13.056,9.548Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  d: "M113.137,42.771A11.487,11.487,0,1,1,101.65,31.283h0a11.487,11.487,0,0,1,11.485,11.487m2.837,0A14.324,14.324,0,1,0,101.65,57.094h0A14.339,14.339,0,0,0,115.974,42.771Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 115.79,
  y: 40.65,
  width: 3.534,
  height: 3.357
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 113.833,
  y: 48.757,
  width: 3.357,
  height: 3.534,
  transform: "translate(12.711 123.515) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 108.1,
  y: 54.649,
  width: 3.357,
  height: 3.534,
  transform: "translate(-13.587 60.295) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 91.889,
  y: 54.816,
  width: 3.534,
  height: 3.357,
  transform: "translate(-3.884 105.982) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 108.013,
  y: 27.448,
  width: 3.534,
  height: 3.357,
  transform: "translate(31.083 111.021) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 91.979,
  y: 27.281,
  width: 3.357,
  height: 3.534,
  transform: "translate(-1.162 54.045) rotate(-32)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 113.745,
  y: 33.338,
  width: 3.534,
  height: 3.357,
  transform: "translate(-1.536 64.494) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 83.979,
  y: 40.65,
  width: 3.534,
  height: 3.357
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 86.024,
  y: 48.846,
  width: 3.534,
  height: 3.357,
  transform: "translate(-13.483 52.432) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 86.112,
  y: 33.25,
  width: 3.357,
  height: 3.534,
  transform: "translate(12.56 92.233) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 100.061,
  y: 24.746,
  width: 3.004,
  height: 4.065
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 100.061,
  y: 56.731,
  width: 3.004,
  height: 4.065
}), /*#__PURE__*/React.createElement("path", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  d: "M90.347,69.971A10.526,10.526,0,1,1,79.821,59.445h0A10.526,10.526,0,0,1,90.347,69.971m2.6,0A13.125,13.125,0,1,0,79.821,83.1h0A13.139,13.139,0,0,0,92.946,69.971Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 92.778,
  y: 68.027,
  width: 3.238,
  height: 3.076
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 90.984,
  y: 75.456,
  width: 3.076,
  height: 3.238,
  transform: "translate(-21.197 116.686) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 85.731,
  y: 80.854,
  width: 3.076,
  height: 3.238,
  transform: "translate(-29.042 52.65) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 70.877,
  y: 81.008,
  width: 3.238,
  height: 3.076,
  transform: "translate(-35.923 100.284) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 85.651,
  y: 55.931,
  width: 3.238,
  height: 3.076,
  transform: "translate(-5.303 105.936) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 70.96,
  y: 55.778,
  width: 3.076,
  height: 3.238,
  transform: "translate(-19.4 47.14) rotate(-32)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 90.904,
  y: 61.327,
  width: 3.238,
  height: 3.076,
  transform: "translate(-19.163 56.632) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 63.629,
  y: 68.027,
  width: 3.238,
  height: 3.076
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 65.503,
  y: 75.538,
  width: 3.238,
  height: 3.076,
  transform: "translate(-30.11 45.579) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 65.584,
  y: 61.247,
  width: 3.076,
  height: 3.238,
  transform: "translate(-21.335 88.022) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 78.366,
  y: 53.455,
  width: 2.752,
  height: 3.725
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 78.366,
  y: 82.762,
  width: 2.752,
  height: 3.725
}), /*#__PURE__*/React.createElement("path", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  d: "M90.348,69.971A10.526,10.526,0,1,1,79.823,59.445h0A10.526,10.526,0,0,1,90.348,69.971m2.6,0A13.125,13.125,0,1,0,79.823,83.1h0A13.139,13.139,0,0,0,92.948,69.971Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 92.779,
  y: 68.027,
  width: 3.238,
  height: 3.076
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 90.986,
  y: 75.456,
  width: 3.076,
  height: 3.238,
  transform: "translate(-21.196 116.687) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 85.733,
  y: 80.854,
  width: 3.076,
  height: 3.238,
  transform: "translate(-29.042 52.65) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 70.879,
  y: 81.008,
  width: 3.238,
  height: 3.076,
  transform: "translate(-35.923 100.285) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 85.653,
  y: 55.931,
  width: 3.238,
  height: 3.076,
  transform: "translate(-5.302 105.937) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 70.961,
  y: 55.778,
  width: 3.076,
  height: 3.238,
  transform: "matrix(0.848, -0.53, 0.53, 0.848, -19.4, 47.14)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 90.905,
  y: 61.327,
  width: 3.238,
  height: 3.076,
  transform: "translate(-19.163 56.633) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 63.631,
  y: 68.027,
  width: 3.238,
  height: 3.076
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 65.505,
  y: 75.538,
  width: 3.238,
  height: 3.076,
  transform: "translate(-30.11 45.58) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 65.585,
  y: 61.247,
  width: 3.076,
  height: 3.238,
  transform: "translate(-21.334 88.024) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 78.367,
  y: 53.455,
  width: 2.752,
  height: 3.725
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 78.367,
  y: 82.762,
  width: 2.752,
  height: 3.725
}), /*#__PURE__*/React.createElement("path", {
  className: "8cbf06d0-48b8-4851-867c-3ab61e906cfa",
  d: "M72.148,21.007a1.575,1.575,0,0,0-.757-.19c.566.115.879.893,1.439.943.258.023.246-.024.11-.183C72.731,21.335,72.37,21.23,72.148,21.007Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "8cbf06d0-48b8-4851-867c-3ab61e906cfa",
  d: "M70.429,23.378a1.167,1.167,0,0,0-.524-.355,1.33,1.33,0,0,0-.917-.072c.054.115.194.153.317.188a2.208,2.208,0,0,1,.541.243c.153.092.494.515.654.514C70.746,23.892,70.517,23.491,70.429,23.378Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  d: "M113.139,42.771a11.487,11.487,0,1,1-11.487-11.487h0a11.487,11.487,0,0,1,11.485,11.487m2.837,0a14.324,14.324,0,1,0-14.324,14.324h0A14.339,14.339,0,0,0,115.976,42.771Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 115.792,
  y: 40.65,
  width: 3.534,
  height: 3.357
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 113.835,
  y: 48.757,
  width: 3.357,
  height: 3.534,
  transform: "translate(12.712 123.517) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 108.102,
  y: 54.649,
  width: 3.357,
  height: 3.534,
  transform: "translate(-13.587 60.296) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 91.891,
  y: 54.816,
  width: 3.534,
  height: 3.357,
  transform: "translate(-3.883 105.983) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 108.014,
  y: 27.448,
  width: 3.534,
  height: 3.357,
  transform: "translate(31.084 111.023) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 91.98,
  y: 27.281,
  width: 3.357,
  height: 3.534,
  transform: "translate(-1.162 54.046) rotate(-32)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 113.746,
  y: 33.338,
  width: 3.534,
  height: 3.357,
  transform: "translate(-1.536 64.495) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 83.98,
  y: 40.65,
  width: 3.534,
  height: 3.357
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 86.025,
  y: 48.846,
  width: 3.534,
  height: 3.357,
  transform: "translate(-13.482 52.433) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 86.114,
  y: 33.25,
  width: 3.357,
  height: 3.534,
  transform: "matrix(0.515, -0.857, 0.857, 0.515, 12.561, 92.234)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 100.063,
  y: 24.746,
  width: 3.004,
  height: 4.065
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 100.063,
  y: 56.731,
  width: 3.004,
  height: 4.065
}), /*#__PURE__*/React.createElement("path", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  d: "M68.348,45.893A9.445,9.445,0,1,1,58.9,36.448h0a9.445,9.445,0,0,1,9.444,9.445m2.332,0A11.777,11.777,0,1,0,58.9,57.67h0A11.79,11.79,0,0,0,70.681,45.893Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 70.53,
  y: 44.149,
  width: 2.906,
  height: 2.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 68.92,
  y: 50.815,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.709 85.607) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 64.206,
  y: 55.659,
  width: 2.76,
  height: 2.906,
  transform: "translate(-19.465 38.958) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 50.878,
  y: 55.796,
  width: 2.906,
  height: 2.76,
  transform: "translate(-23.889 71.256) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 64.135,
  y: 33.294,
  width: 2.906,
  height: 2.76,
  transform: "translate(3.463 75.228) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 50.951,
  y: 33.157,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.389 32.991) rotate(-32)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 68.848,
  y: 38.137,
  width: 2.906,
  height: 2.76,
  transform: "translate(-10.311 41.852) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 44.374,
  y: 44.149,
  width: 2.906,
  height: 2.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 46.055,
  y: 50.888,
  width: 2.906,
  height: 2.76,
  transform: "matrix(0.857, -0.515, 0.515, 0.857, -20.134, 31.934)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 46.128,
  y: 38.064,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.833 59.887) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 57.597,
  y: 31.072,
  width: 2.47,
  height: 3.342
}), /*#__PURE__*/React.createElement("rect", {
  className: "083a53d4-6237-422f-b786-ee3c3dc67dff",
  x: 57.597,
  y: 57.371,
  width: 2.47,
  height: 3.342
}), /*#__PURE__*/React.createElement("path", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  d: "M68.421,45.893a9.445,9.445,0,1,1-9.445-9.445h0a9.445,9.445,0,0,1,9.444,9.445m2.332,0A11.777,11.777,0,1,0,58.976,57.67h0A11.79,11.79,0,0,0,70.753,45.893Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 70.602,
  y: 44.149,
  width: 2.906,
  height: 2.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 68.993,
  y: 50.815,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.674 85.67) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 64.279,
  y: 55.659,
  width: 2.76,
  height: 2.906,
  transform: "translate(-19.456 38.993) rotate(-29)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 50.95,
  y: 55.796,
  width: 2.906,
  height: 2.76,
  transform: "translate(-23.855 71.318) rotate(-58)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 64.207,
  y: 33.294,
  width: 2.906,
  height: 2.76,
  transform: "translate(3.501 75.292) rotate(-61)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 51.024,
  y: 33.157,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.378 33.029) rotate(-32)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 68.921,
  y: 38.137,
  width: 2.906,
  height: 2.76,
  transform: "translate(-10.301 41.889) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 44.446,
  y: 44.149,
  width: 2.906,
  height: 2.76
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 46.128,
  y: 50.888,
  width: 2.906,
  height: 2.76,
  transform: "translate(-20.124 31.971) rotate(-31)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 46.2,
  y: 38.064,
  width: 2.76,
  height: 2.906,
  transform: "translate(-10.798 59.949) rotate(-59)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 57.67,
  y: 31.072,
  width: 2.47,
  height: 3.342
}), /*#__PURE__*/React.createElement("rect", {
  className: "eb52c4bf-ee7c-4861-8337-fa16df875521",
  x: 57.67,
  y: 57.371,
  width: 2.47,
  height: 3.342
}));

var SvgIndustry01 = function SvgIndustry01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 163.336 110",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndustry01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/industry-01.82df7955.svg";
export { ForwardRef as ReactComponent };